import {AxiosResponse} from "axios";

import CoreApi from "@/src/modules/core/api";
import {axios} from "@/src/modules/core/lib";

import type {
  DiscardResponse,
  MarkReadResponse,
  NotificationActionRequest,
  NotificationFeedQueryParams,
  NotificationFeedResponse,
} from "../types";

const PATH = "notifications";

class NotificationFeedApi extends CoreApi {
  getNotifications(
    params?: NotificationFeedQueryParams,
  ): Promise<AxiosResponse<NotificationFeedResponse>> {
    return axios({
      url: PATH,
      method: "get",
      params,
    });
  }

  markRead(data: NotificationActionRequest): Promise<AxiosResponse<MarkReadResponse>> {
    return super.post(`${PATH}/mark-read`, data);
  }

  discard(data: NotificationActionRequest): Promise<AxiosResponse<DiscardResponse>> {
    return super.post(`${PATH}/discard`, data);
  }
}

export const notificationFeedApi = new NotificationFeedApi();
